import {
  select,
  zoomTransform,
  event,
  line as lineD3,
  format,
  zoom,
  axisRight
} from "d3";
import {
  inRange,
  mouseDate,
  roundDate,
  zoomSetup
} from "@/_core/charts/TechnicalAnalysis";

export function CommitmentTradersHover(_this, D3Chart) {
  const auxName = "COT";
  function mouseover() {
    if (_this.transform === undefined || _this.transform == null) {
      _this.transform = zoomTransform(
        select(".hoverParent" + auxName)._groups[0][0]
      );
    }

    event.preventDefault();
    const xPixels = Math.max(
      Math.min(event.layerX - _this.svgNode.margin.left, _this.svgNode.width),
      0
    );
    var xt = _this.transform.rescaleX(_this.svgNode.x);
    let ytY = _this.svgNode.y;
    let dat = roundDate(xt.invert(xPixels));
    let selData;

    let highlightCandles = true;
    if (
      dat <= _this.allData.historical[_this.allData.historical.length - 1].date
    ) {
      selData = mouseDate(xt.invert(xPixels), _this.allData.historical);
    } else {
      selData = JSON.parse(
        JSON.stringify(
          _this.allData.historical[_this.allData.historical.length - 1]
        )
      );
      selData["date"] = dat;
      highlightCandles = false;
    }
    const yPixels = Math.max(
      Math.min(event.layerY - _this.svgNode.margin.top, _this.svgNode.height),
      0
    );

    const xPix = xt(selData.date);

    select(".vHoverLineNet")
      .style("opacity", 1)
      .attr("x1", xPix)
      .attr("x2", xPix);

    select(".vHoverLineopen-interest")
      .style("opacity", 1)
      .attr("x1", xPix)
      .attr("x2", xPix);
    let bandWidth = _this.transform.k * _this.bandWidth;
    const candleWidth = bandWidth * _this.barWidth + 1;
    // Showing elements
    for (let hoverElement of D3Chart.hoverElements) {
      hoverElement.show({
        yPixels,
        xPix,
        selData,
        dateFormat: _this.dateFormat,
        xt,
        candleWidth,
        highlightCandles
      });
    }
    for (let hereditaryHover of D3Chart.hereditaryHovers) {
      hereditaryHover.show({
        yPixels,
        xPix,
        selData,
        dataYt: selData,
        dateFormat: _this.dateFormat,
        xt,
        candleWidth,
        keyYt: "close",
        highlightCandles
      });
    }
    // Showing dots
    for (let hoverElementDot of D3Chart.hoverElementDots) {
      hoverElementDot.show({
        xPix,
        yt: ytY,
        dataYt: selData,
        keyYt: "close",
        highlightCandles
      });
    }

    if (highlightCandles) {
      const yt3 = _this.svgNodeNet.y;

      if (_this.userSelections["showComm"]) {
        select(".barCHistogram")
          .style("opacity", 1)
          .attr("x", xPix - candleWidth / 2)
          .attr("y", Math.min(yt3(0), yt3(selData["commercial_net"])))
          .attr(
            "height",
            Math.max(1, Math.abs(yt3(0) - yt3(selData["commercial_net"])))
          )
          .attr("width", candleWidth);
      }
      if (_this.userSelections["showNonComm"]) {
        select(".barNCHistogram")
          .style("opacity", 1)
          .attr("x", xPix - candleWidth / 2)
          .attr("y", Math.min(yt3(0), yt3(selData["non_commercial_net"])))
          .attr(
            "height",
            Math.max(1, Math.abs(yt3(0) - yt3(selData["non_commercial_net"])))
          )
          .attr("width", candleWidth);
      }
      if (_this.userSelections["showNonRep"]) {
        select(".barNRHistogram")
          .style("opacity", 1)
          .attr("x", xPix - candleWidth / 2)
          .attr("y", Math.min(yt3(0), yt3(selData["non_rep_net"])))
          .attr(
            "height",
            Math.max(1, Math.abs(yt3(0) - yt3(selData["non_rep_net"])))
          )
          .attr("width", candleWidth);
      }

      const ytOI = _this.svgNodeOI.y;

      select(".barOIHist")
        .style("opacity", 1)
        .attr("x", xPix - candleWidth / 2)
        .attr("y", Math.min(ytOI(0), ytOI(selData["open_interest"])))
        .attr(
          "height",
          Math.max(1, Math.abs(ytOI(0) - ytOI(selData["open_interest"])))
        )
        .attr("width", candleWidth);
    } else {
      if (_this.userSelections["showComm"]) {
        select(".barCHistogram").style("opacity", 0);
      }
      if (_this.userSelections["showNonComm"]) {
        select(".barNCHistogram").style("opacity", 0);
      }
      if (_this.userSelections["showNonRep"]) {
        select(".barNRHistogram").style("opacity", 0);
      }
      select(".barOIHist").style("opacity", 0);
    }
    displayDataCOT(selData, _this);
  }
  function mouseout() {
    if (_this.userSelections["showComm"]) {
      select(".barCHistogram").style("opacity", 0);
    }
    if (_this.userSelections["showNonComm"]) {
      select(".barNCHistogram").style("opacity", 0);
    }
    if (_this.userSelections["showNonRep"]) {
      select(".barNRHistogram").style("opacity", 0);
    }
    select(".vHoverLineNet").style("opacity", 0);
    select(".barOIHist").style("opacity", 0);
    select(".vHoverLineopen-interest").style("opacity", 0);
    select(".vHoverLinecommitmentTraders").style("opacity", 0);

    // Hiding elements
    for (let hoverElement of D3Chart.hoverElements) {
      hoverElement.hide();
    }
    // Hiding dot
    for (let hoverElement of D3Chart.hoverElementDots) {
      hoverElement.hide();
    }
    // Hiding hereditary hovers
    for (let hereditaryHover of D3Chart.hereditaryHovers) {
      hereditaryHover.hide();
    }

    displayDataCOT(
      _this.allData.historicalSliced[_this.allData.historicalSliced.length - 1],
      _this
    );
  }

  function zoomed() {
    if (!_this.keepDateInterval) {
      setTimeout(() => {
        _this.pickedDateInterval = "-1";
      }, 500);
    }
    if (_this.userSelections["showComm"]) {
      select(".barCHistogram").style("opacity", 0);
    }
    if (_this.userSelections["showNonComm"]) {
      select(".barNCHistogram").style("opacity", 0);
    }
    if (_this.userSelections["showNonRep"]) {
      select(".barNRHistogram").style("opacity", 0);
    }
    select(".vHoverLineNet").style("opacity", 0);
    select(".barOIHist").style("opacity", 0);
    select(".vHoverLineopen-interest").style("opacity", 0);
    // Hiding elements
    for (let hoverElement of D3Chart.hoverElements) {
      hoverElement.hide();
    }
    _this.transform = event.transform;
    _this.svgNode.gX.call(
      _this.svgNode.xAxis.scale(_this.transform.rescaleX(_this.svgNode.x))
    );
    const xt = _this.transform.rescaleX(_this.svgNode.x);
    COTZooming(xt, _this);

    // transform other charts
    if (_this.externalZoom === false) {
      _this.externalZoom = true;
      select(".hoverParentNet").call(_this.zoomNet.transform, _this.transform);
      select(".hoverParentOI").call(_this.zoomOI.transform, _this.transform);

      _this.externalZoom = false;
    }

    _this.keepDateInterval = false;
  }

  function zoomEnd() {
    _this.transform = event.transform;
    const xt = _this.transform.rescaleX(_this.svgNode.x);
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      var xmin = new Date(xt.invert(0));
      var xmax = new Date(xt.invert(_this.svgNode.width));

      if (!_this.externalZoom) {
        let data = _this.allData.historical.map(d => d);
        _this.allData.historicalSliced = data.filter(function(d) {
          return inRange(d.date, xmin, xmax);
        });
      }

      let minMaxYAxis, minMaxYAxis2;
      minMaxYAxis = _this.getMinMaxYAxis();
      minMaxYAxis2 = [minMaxYAxis[2], minMaxYAxis[3]];
      minMaxYAxis = [minMaxYAxis[0], minMaxYAxis[1]];

      if (!isFinite(minMaxYAxis[0])) {
        minMaxYAxis[0] = -1;
      }
      if (!isFinite(minMaxYAxis[1])) {
        minMaxYAxis[1] = 1;
      }
      if (!isFinite(minMaxYAxis2[0])) {
        minMaxYAxis2[0] = -1;
      }
      if (!isFinite(minMaxYAxis2[1])) {
        minMaxYAxis2[1] = 1;
      }
      _this.svgNode.y.domain(minMaxYAxis);
      let yt = _this.svgNode.y;
      yt.domain(minMaxYAxis);

      COTZoomEnd(
        _this.transform,
        xt,
        yt,
        _this.allData.historicalSliced,
        _this
        // lastYTooltip,
        // valueLast
      );
    }, 200);
  }

  let resizeTimer;
  zoomSetup(
    _this,
    "svgNode",
    "zoom" + auxName,
    auxName,
    "",
    mouseover,
    mouseout,
    zoomed,
    zoomEnd
  );
  displayDataCOT(
    _this.allData.historicalSliced[_this.allData.historicalSliced.length - 1],
    _this
  );

  // updating the y-axis domain when zooming
  const yInit = _this.svgNode.y.copy();

  function draw() {
    // cursor drag & drop (north-south resize)
    _this.svgNode.gYRect.style("cursor", "ns-resize");
    // update y-axis
    _this.svgNode.gY
      .transition()
      .call(_this.svgNode.yAxis.scale(_this.svgNode.y));
  }
  function zoomedY() {
    // update y-axis scale
    _this.svgNode.y.domain(event.transform.rescaleY(yInit).domain());
    _this.svgNode.gY.call(
      _this.svgNode.yAxis.scale(event.transform.rescaleY(_this.svgNode.y))
    );
    _this.svgNode.y = event.transform.rescaleY(_this.svgNode.y);

    draw();

    // update line and area path
    const xt = _this.transform.rescaleX(_this.svgNode.x);

    COTZooming(xt, _this);
    COTZoomEnd(
      _this.transform,
      xt,
      _this.svgNode.y,
      _this.allData.historicalSliced,
      _this
    );
  }

  const zoomY = zoom().on("zoom", zoomedY);
  _this.svgNode.gYRect.call(zoomY);

  select(".hoverParent" + auxName).call(
    _this.zoomCOT.transform,
    _this.transform
  );
}

export function COTZooming(xt, _this) {
  let line, fieldName;
  line = lineD3()
    .defined(d => d[_this.fieldUp])
    .x(d => xt(d.date))
    .y(d => _this.svgNode.y(d[_this.fieldUp]));
  _this.svgNode["close"].attr("d", d => line(d));
  fieldName = "pHighlight";
  line = lineD3()
    .defined(d => d[fieldName])
    .x(d => xt(d.date))
    .y(d => _this.svgNode.y(d[fieldName]));
  _this.svgNode["highlightLine"].attr("d", d => line(d));
}

export function COTZoomEnd(t, xt, yt, filtered, _this) {
  let line, fieldName;

  line = lineD3()
    .defined(d => d[_this.fieldUp])
    .x(d => xt(d.date))
    .y(d => yt(d[_this.fieldUp]));
  _this.svgNode["close"]
    .data([filtered])
    .join("path")
    .attr("d", d => line(d));

  fieldName = "pHighlight";
  line = lineD3()
    .defined(d => d[fieldName])
    .x(d => xt(d.date))
    .y(d => _this.svgNode.y(d[fieldName]));
  _this.svgNode["highlightLine"]
    .data([filtered])
    .join("path")
    .attr("d", d => line(d));

  // y axis
  _this.svgNode["zeroLineCOT"].attr("y1", yt(0)).attr("y2", yt(0));
  for (let zoomElement of _this.D3ChartCOT.zoomElements) {
    zoomElement.recalculate();
  }
  let tickCount = _this.svgNode.height / 40;
  _this.svgNode.gY
    .transition()
    .duration(500)
    .call(
      axisRight()
        .tickSize(-_this.svgNode.width)
        .ticks(tickCount)
        .tickSizeOuter(0)
        .tickPadding(10)
        .scale(yt)
    );
}

export function displayDataCOT(d, _this) {
  select("#closeCOT").text(format(_this.currencyFormat)(d.close));
  select("#barNCHistogram").text(
    format(_this.currencyFormat)(d.non_commercial_net)
  );
  select("#barNRHistogram").text(format(_this.currencyFormat)(d.non_rep_net));
  select("#barCHistogram").text(format(_this.currencyFormat)(d.commercial_net));
  select("#barOIHistogram").text(format(_this.currencyFormat)(d.open_interest));
}
